module.exports = __webpack_public_path__ + "static/lightning-75197e32465053ce48b5e8c77e078111.jpg";